namespace Nobox.Membership {
    export enum OptionRegister {
        Punya = 1,
        Gapunya = 2
    }
    Serenity.Decorators.registerEnumType(OptionRegister, 'Nobox.Membership.OptionRegister', 'Nobox.OptionRegister');
}
